import React, { Component } from 'react';
import { withRouter } from 'react-router'

class Public extends Component {

  render() {
    return (
      <div>
        <div className="public-component">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default withRouter(Public);


// WEBPACK FOOTER //
// ./src/components/public/Public.js